import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@homeleite/arch';
import { last, Observable, takeWhile, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IntegrationApiService {

    constructor(private api: ApiService) {}

    public fetch(producerCode?: string, since?: string): void {
        const endpoint = this.api.root.path('integration', 'fetch');

        let params = new HttpParams();
        if (producerCode) params = params.set('producerId', producerCode);
        if (since) params = params.set('since', since);

        endpoint.postJson<void>(null, { params }).subscribe({
            error: err => console.error('Erro ao iniciar fetch', err)
        });
    }


    public fetchStatus(producerCode: string): Observable<{ status: string }> {
        const endpoint = this.api.root.path('integration', 'fetch-status');
        const params = new HttpParams().set('producerId', producerCode);
        return endpoint.getJson<{ status: string }>({ params });
    }

    public fetchAndWait(producerCode?: string, since?: string): Observable<string> {
        return new Observable<string>(observer => {
            this.fetch(producerCode, since);

            timer(5000, 20000).pipe(
                switchMap(() => this.fetchStatus(producerCode)),
                takeWhile(res => res.status.toUpperCase() === 'PROCESSING', true),
                last()
            ).subscribe({
                next: res => {
                    observer.next(res.status);
                    observer.complete();
                },
                error: err => observer.error(err)
            });
        });
    }
}
